<template>
  <div class="written">
    <div class="login">
      <div class="user">
        <p class="user-head">
          <img :src="user_info.user_avatar" alt="" />
        </p>
        <p class="user-name">
          <span :title="user_info.user_name">{{ user_info.user_name }}</span
          ><a :href="logout_url">退出</a>
        </p>
      </div>
      <div class="user-info">
        <span>我的贡献值<br />{{ user_info.points }}</span>
        <button
          @click="handleMyPrize"
          class="cat-prize"
          :class="{ disabled: !user_awards.length }"
        >
          查看我的奖品
        </button>
      </div>
    </div>
    <div class="written-panel">
      <div class="tabs">
        <a
          @click.prevent="handleSwitch('create')"
          href=""
          :class="{ active: tabsActive == 'create' }"
          >创建新词条</a
        >
        <a
          @click.prevent="handleSwitch('edit')"
          href=""
          :class="{ active: tabsActive == 'edit' }"
          >管理我的创作</a
        >
      </div>
      <div class="form-panel">
        <div class="form" v-if="tabsActive == 'create'">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="标题" prop="title">
              <el-input
                v-model="ruleForm.title"
                placeholder="请填写标题"
                @input="handleTitle"
              ></el-input>
              <span class="num">{{ ruleForm.title.length }}/20</span>
            </el-form-item>
            <el-form-item label="标签">
              <div
                class="label-item"
                :class="{ disabled: labe_tag.length == 3 }"
              >
                <span
                  :class="{ active: labe_tag.indexOf(item) > -1 }"
                  @click="handleSelTag(item)"
                  v-for="item in tag_list"
                  :key="item"
                  >{{ item }}</span
                >
              </div>
            </el-form-item>
            <el-form-item label="正文" prop="content">
              <el-input
                placeholder="请填写正文"
                type="textarea"
                v-model="ruleForm.content"
                @input="handleContent"
              ></el-input>
              <span class="num-tar">{{ ruleForm.content.length }}/350</span>
            </el-form-item>
            <el-form-item class="upload_file" label="图片">
              <el-input class="txt-input"></el-input>
              <el-upload
                class="avatar-uploader"
                :action="UPLOAD_LOGO"
                :show-file-list="false"
                :http-request="httpRequest"
                :before-upload="beforeAvatarUpload"
                name="img"
              >
                <div slot="tip" class="el-upload__tip">
                  <span></span>
                  <p class="tip-msg">
                    {{
                      ruleForm.image_url ||
                        '建议图片尺寸800x450；格式JPG，JPEG，PNG，GIF；不超过2M'
                    }}
                  </p>

                  <el-button
                    @click="handleDelete"
                    v-if="ruleForm.image_url"
                    class="delete-btn"
                    >删除</el-button
                  >
                </div>
                <div class="img-error">{{ load_img_err }}</div>
                <el-button v-if="!ruleForm.image_url" class="upload-btn"
                  >点击上传</el-button
                >
              </el-upload>
            </el-form-item>
            <el-form-item>
              <div class="footer">
                <el-button
                  :class="{ disabled: !ruleForm.title || !ruleForm.content }"
                  @click="handlePreview()"
                  >预览</el-button
                >
                <el-button type="primary" @click="submitForm('ruleForm')"
                  >提交</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="written-item" v-else>
          <div class="t-header">
            <ul>
              <li>
                <span>创建日期</span>
                <span>标题</span>
                <span>点赞数</span>
                <span>当前状态</span>
                <span>操作</span>
              </li>
            </ul>
          </div>
          <div class="t-body">
            <el-scrollbar>
              <ul>
                <li v-for="item in user_items" :key="item.id">
                  <span>{{ item.first_create_time }}</span>
                  <span>{{ item.title }}</span>
                  <span>{{ item.upvote_count }}</span>
                  <span v-if="item.status == 0">待审核</span>
                  <span v-else-if="item.status == 1">已通过审核</span>
                  <span v-else-if="item.status == 2"
                    >未通过审核，{{
                      item.admin_message[item.admin_message.length - 1]
                    }}</span
                  >
                  <span
                    v-else-if="item.status == 3 && item.admin_message.length"
                    >超过审核次数上限，已锁定</span
                  >
                  <span
                    v-else-if="item.status == 3 && !item.admin_message.length"
                    >答复审核结果，词条已冻结</span
                  >
                  <span
                    ><a
                      :class="{
                        disabled: item.status == 3 || item.status == 1,
                      }"
                      href=""
                      @click.prevent="handleModify(item)"
                      >修改</a
                    ></span
                  >
                </li>
              </ul>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogTableVisible" :show-close="false">
      <div class="story-info">
        <button class="x" @click="handleClose"></button>
        <div class="story-container">
          <div class="story-header">
            <h3>{{ ruleForm.title }}</h3>
            <div class="row">
              <div class="col">
                <span
                  >由 <span>{{ user_info.user_name }}</span> 创建的词条</span
                >
                <i
                  v-for="item in ruleForm.tags ? ruleForm.tags.split(',') : []"
                  :key="item"
                  >{{ item }}</i
                >
              </div>
              <div class="col"></div>
            </div>
          </div>
          <div class="story-body">
            <el-scrollbar>
              <p>
                {{ ruleForm.content }}
              </p>
              <div class="img-box">
                <img :src="ruleForm.image_url" alt="" />
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/utils/http'
import { UPLOAD_LOGO, MEMES2020 } from '../api/index'
import { mapMutations } from 'vuex'
import { DIALOG_OPTION } from '../store/mutation-types.js'
import {
  Form,
  FormItem,
  Button,
  Input,
  Upload,
  Scrollbar,
  Dialog,
} from 'element-ui'
export default {
  data() {
    return {
      dialogTableVisible: false, //预览模态框
      UPLOAD_LOGO: UPLOAD_LOGO,
      user_awards: [], //个人奖品
      user_items: [], //管理创作信息
      no_clicking: true, //禁止多次点击
      tabsActive: 'create',
      labe_tag: [],
      load_img_err: '',
      ruleForm: {
        task: 'edit_item',
        id: 0,
        title: '',
        content: '',
        tags: '',
        image_url: '',
      },
      rules: {
        title: [{ required: true, message: ' ', trigger: 'change' }],
        content: [{ required: true, message: ' ', trigger: 'change' }],
      },
    }
  },
  computed: {
    tag_list() {
      return this.$store.state.tag_list
    },
    logout_url() {
      return this.$store.state.base_info.logout_url
    },
    user_info() {
      return this.$store.state.user_info
    },
  },
  components: {
    elForm: Form,
    elFormItem: FormItem,
    elButton: Button,
    elInput: Input,
    elUpload: Upload,
    elScrollbar: Scrollbar,
    elDialog: Dialog,
  },
  mounted() {
    //获取个人数据
    this.getMyInfo()
  },
  methods: {
    ...mapMutations([DIALOG_OPTION]),
    getMyInfo() {
      http
        .post(MEMES2020, {
          task: 'my_info',
        })
        .then(data => {
          if (data.status == 'success') {
            let { user_info, user_awards, user_items, tag_list } = data.result
            this.user_awards = user_awards
            this.user_items = user_items
            this.$store.state.user_prize = user_awards
            this.$store.state.tag_list = tag_list
            this.$store.state.user_info = user_info
          }
        })
    },
    handleModify(item) {
      //修改条目
      this.labe_tag = item.tags
      this.ruleForm = {
        task: 'edit_item',
        id: item.id,
        title: item.title,
        content: item.content,
        tags: item.tags.join(),
        image_url: item.image_url,
      }
      this.tabsActive = 'create'
    },
    handleSwitch(type) {
      //切换词条创建和管理
      this.tabsActive = type
    },
    handleSelTag(tag) {
      //选择标签
      if (this.labe_tag.includes(tag)) {
        this.labe_tag.splice(this.labe_tag.indexOf(tag), 1)
      } else {
        if (this.labe_tag.length < 3) this.labe_tag.push(tag)
      }
      this.ruleForm.tags = this.labe_tag.join()
    },
    beforeAvatarUpload(file) {
      const isImg = /\.(jpg|gif|jpeg|png)+$/g.test(file.name.toLowerCase())
      const isSize = file.size < 1024 * 1024 * 2
      if (!isImg) {
        this.load_img_err = '图片格式仅支持JPG，JPEG，PNG，GIF；大小不超过2MB'
        setTimeout(() => {
          this.load_img_err = ''
        }, 2000)
      } else if (!isSize) {
        this.load_img_err = '图片格式仅支持JPG，JPEG，PNG，GIF；大小不超过2MB'
        setTimeout(() => {
          this.load_img_err = ''
        }, 2000)
      }
      return isImg && isSize
    },
    httpRequest(file) {
      let formData = new FormData()
      formData.append('qqfile', file.file)
      http.postFile(UPLOAD_LOGO, formData).then(data => {
        if (data.status == 'success') {
          this.ruleForm.image_url = data.file
        }
      })
    },
    handleDelete() {
      //删除上传的图片
      this.ruleForm.image_url = ''
    },
    handleTitle() {
      if (this.ruleForm.title.length > 20) {
        this.ruleForm.title = this.ruleForm.title.substring(0, 20)
      }
    },
    handleContent() {
      if (this.ruleForm.content.length > 350) {
        this.ruleForm.content = this.ruleForm.content.substring(0, 350)
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.no_clicking) return
          this.no_clicking = false
          http.post(MEMES2020, this.ruleForm).then(data => {
            if (data.status == 'success') {
              this.$store.commit(DIALOG_OPTION, {
                dialogTableVisible: true,
                type: 'MESSAGE',
                data: {
                  content: data.result,
                },
              })
              this.tabsActive = 'edit'
              this.formInit()
              this.getMyInfo()
            } else {
              this.$store.commit(DIALOG_OPTION, {
                dialogTableVisible: true,
                type: 'MESSAGE',
                data: {
                  content: data.error,
                },
              })
            }
            setTimeout(() => (this.no_clicking = true), 100)
          })
          setTimeout(() => (this.no_clicking = true), 30100)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    formInit() {
      this.labe_tag = []
      this.ruleForm = {
        task: 'edit_item',
        id: 0,
        title: '',
        content: '',
        tags: '',
        image_url: '',
      }
    },
    handleMyPrize() {
      //查看我的奖品
      this.$store.commit(DIALOG_OPTION, {
        dialogTableVisible: true,
        type: 'EVENTS_PRIZE',
        data: {
          title: '我的奖品',
          prize: this.user_awards,
        },
      })
    },
    handleClose() {
      //关闭弹框
      this.dialogTableVisible = false
    },
    handlePreview() {
      //预览
      this.dialogTableVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.written {
  font-size: 14px;
  height: 1152px;
  background: url('https://img.dota2.com.cn/file/9d/a3/9da31a679aa87556867deefebd82e90e1596110470.jpg')
    no-repeat center top;
  .login {
    margin: 0 auto;
    width: 720px;
    height: 176px;
    background-color: rgba(34, 37, 41, 0.5);
    border-radius: 10px;
    padding-top: 30px;
    .user {
      float: left;
      text-align: center;
      width: 228px;
      height: 114px;
      border-right: 1px solid #19515b;
      .user-head {
        margin: 0 auto;
        width: 88px;
        height: 88px;
        background-color: #123d44;
        border: solid 2px #1f96a4;
        overflow: hidden;
        border-radius: 44px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .user-name {
        color: #cfcfcf;
        margin-top: 10px;
        span,
        a {
          display: inline-block;
          vertical-align: middle;
        }
        span {
          display: inline-block;
          max-width: 160px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        a {
          color: #79e4f7;
          text-decoration: underline;
          margin-left: 6px;
        }
      }
    }
    .user-info {
      float: left;
      padding-left: 93px;
      span {
        vertical-align: middle;
        margin-top: 30px;
        display: inline-block;
        margin-right: 79px;
        width: 100px;
        text-align: center;
        font-size: 20px;
        color: #79e4f7;
        line-height: 150%;
      }
      .cat-prize {
        vertical-align: middle;
        display: inline-block;
        margin-top: 31px;
        width: 160px;
        height: 54px;
        background-color: #186d81;
        border-radius: 5px;
        letter-spacing: 1px;
        cursor: pointer;
        color: #ddf9fd;
        font-size: 16px;
        &.disabled {
          pointer-events: none;
          color: #4f545d;
          background-color: #21252a;
        }
      }
    }
  }
  .written-panel {
    .tabs {
      width: 350px;
      margin: 25px auto 0;
      border-bottom: 1px solid #36373a;
      a {
        position: relative;
        letter-spacing: 1px;
        color: #cfcfcf;
        font-size: 20px;
        display: inline-block;
        width: 50%;
        height: 52px;
        line-height: 52px;
        text-align: center;
        position: relative;
        transition: all 0.2s;
        &:hover,
        &.active {
          color: #fa9a28;
          &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: -1px;
            width: 100%;
            height: 0;
            border-top: 2px solid #fa9a28;
          }
        }
      }
    }
    .form-panel {
      width: 1200px;
      min-height: 780px;
      margin: 30px auto 0;
      color: #9a9a9a;
      .img-error {
        position: absolute;
        left: 20px;
        top: 40px;
        color: #f56c6c;
      }
      /deep/ input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #9a9a9a;
      }
      /deep/ input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #9a9a9a;
      }
      /deep/ input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #9a9a9a;
      }
      /deep/ input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #9a9a9a;
      }

      /deep/ textarea::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #9a9a9a;
      }
      /deep/ textarea:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #9a9a9a;
      }
      /deep/ textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #9a9a9a;
      }
      /deep/ textarea:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #9a9a9a;
      }
      .form {
        padding: 40px 163px 20px;
        background-color: #232529;
        height: 100%;
        border-radius: 6px;
        .delete-btn {
          float: right;
          margin-top: -3px;
        }
        .tip-msg {
          display: inline-block;
          width: 355px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          vertical-align: middle;
          margin-top: -2px;
        }
        .num {
          position: absolute;
          right: 290px;
          top: 15px;
          line-height: 100%;
        }
        .num-tar {
          position: absolute;
          right: -10px;
          top: 386px;
          line-height: 100%;
        }
        .label-item /deep/.el-form-item__error {
          top: 40px;
        }
        .label-item {
          margin-top: 3px;

          &.disabled {
            span {
              cursor: no-drop;
            }
          }
          span {
            padding: 8px 12px;
            background-color: #34373d;
            border-radius: 39px;
            letter-spacing: 1px;
            color: #9a9a9a;
            margin-left: 6px;
            transition: all 0.2s;
            border: 1px solid transparent;
            cursor: pointer;
            &:first-child {
              margin-left: 0;
            }
            &.active {
              background-color: #fa9a28;
              color: #fff;
              cursor: pointer;
            }
          }
        }
      }
      .footer {
        text-align: center;
        padding-top: 20px;
        .el-button {
          width: 160px;
          height: 48px;
          background-color: #232529;
          border-radius: 5px;
          border: solid 1px #fa9a28;
          color: #fa9a28;
          font-size: 16px;
          transition: all 0.2s;
          &.disabled {
            border-color: #666;
            pointer-events: none;
            color: #999;
          }
          &:first-child {
            margin-right: 8px;
          }
          &:last-child {
            background-color: #fa9a28;
            color: #fff;
          }
        }
      }
      .written-item {
        border-radius: 6px;
        padding: 38px 10px 0 40px;
        background-color: #232529;
        ul {
          li {
            height: 72px;
            border-bottom: 1px solid #33383c;
            span {
              height: 72px;
              line-height: 72px;
              float: left;
              &:nth-child(1) {
                width: 230px;
                padding-left: 45px;
              }
              &:nth-child(2) {
                width: 310px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              &:nth-child(3) {
                width: 80px;
                text-align: center;
              }
              &:nth-child(4) {
                width: 340px;
                text-align: center;
              }
              &:nth-child(5) {
                width: 160px;
                text-align: center;
                a {
                  letter-spacing: 1px;
                  color: #fa9a28;
                  &.disabled {
                    pointer-events: none;
                    color: #5a5a5a;
                    &::before {
                      background-position-y: bottom;
                    }
                  }
                  &::before {
                    content: '';
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 5px;
                    width: 15px;
                    height: 15px;
                    background-image: url(https://img.dota2.com.cn/file/df/66/df66a990827e292032f8971aab1bde901596425453.png);
                  }
                }
              }
            }
          }
        }
        .t-header {
          width: 1120px;
          height: 48px;
          background-color: #34373d;
          border-radius: 8px;
          ul {
            li {
              border-bottom: none;
              span {
                height: 48px;
                line-height: 48px;
                font-weight: bold;
              }
            }
          }
        }
        .t-body {
          height: 642px;
          ul {
            margin-right: 30px;
          }
        }
      }

      /deep/ .el-input__inner {
        width: 500px;
        height: 46px;
        background-color: #34373d;
        border-radius: 5px;
        font-size: 14px;
        border-color: transparent;
        color: #9a9a9a;
        font-family: 'Microsoft YaHei';
      }
      /deep/ .el-textarea__inner {
        width: 800px;
        height: 420px;
        background-color: #34373d;
        border-radius: 5px;
        border-color: transparent;
        color: #9a9a9a;
        font-family: 'Microsoft YaHei';
        resize: none;
      }
      /deep/ .el-form-item__label {
        color: #9a9a9a;
        line-height: 46px;
      }
      /deep/ .avatar-uploader {
        width: 500px;
        padding-left: 20px;
        margin-top: -49px;
        position: relative;
        .el-upload {
          float: right;
        }
        .el-button {
          background-color: transparent;
          color: #fa9a28;
          border: none;
          height: 46px;
        }
        .el-upload__tip {
          color: #bdbdbd;
          font-size: 12px;
          margin-top: 3px;
          height: 46px;
          padding-top: 3px;
          > span {
            position: relative;
            content: '';
            margin-right: 10px;
            width: 19px;
            height: 17px;
            display: inline-block;
            vertical-align: middle;
            background-image: url(https://img.dota2.com.cn/file/cf/a0/cfa053e139345dc7fa03cf3246389a431596423523.png);
            img {
              position: absolute;
              bottom: 26px;
              width: 0px;
              height: 0px;
              transition: all 0.2s;
              transform-origin: center;
            }
            &:hover {
              img {
                width: 200px;
                height: 200px;
              }
            }
          }
        }
      }
      /deep/ .el-form-item.is-error .el-input__inner,
      /deep/ .el-form-item.is-error .el-textarea__inner {
        border-color: #f56c6c;
      }
    }
  }
}

.story-info {
  position: relative;
  width: 986px;
  margin: 0 auto;
  height: 776px;
  padding-top: 64px;
  font-size: 14px;
  background-image: url(https://img.dota2.com.cn/file/5f/00/5f0095a98ce0b4738372608125ee8b841596100336.png);
  .prev,
  .next {
    position: absolute;
    top: 50%;
    margin-top: -30px;
    width: 60px;
    height: 60px;
    background-image: url('../assets/swiper-btn-next.png');
    background-position: right top;
    cursor: pointer;
    &:hover {
      background-position-x: -90px;
    }
    &.disabled {
      pointer-events: none;
      background-position-x: 0;
    }
  }
  .prev {
    left: -30px;
  }
  .next {
    right: -30px;
    transform: rotate(180deg);
  }
  .story-container {
    width: 860px;
    margin: 0 auto;
    padding: 0 10px 0 40px;
  }
  .story-header {
    padding-top: 40px;
    h3 {
      font-size: 36px;
      color: #fff;
      line-height: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
    }
    .row {
      padding-top: 20px;
      .col {
        &:first-child {
          float: left;
          color: #cfcfcf;
          > span {
            margin-right: 15px;
            span {
              color: #fa9a28;
            }
          }
          i {
            font-style: normal;
            background-color: #042b33;
            padding: 5px 12px;
            line-height: 100%;
            border-radius: 29px;
            margin: 0 5px;
          }
        }
        &:last-child {
          float: right;
          color: #b5f0fa;
          > div {
            position: relative;
            cursor: pointer;
            i,
            span {
              display: inline-block;
              vertical-align: middle;
            }
            display: inline-block;
            vertical-align: middle;
            margin-left: 14px;
            i {
              width: 18px;
              height: 17px;
              margin-right: 6px;
              background-image: url('../assets/icon-share2.png');
            }
            &:hover {
              .tip {
                opacity: 1;
              }
            }
            .tip {
              opacity: 0;
              pointer-events: none;
              position: absolute;
              left: -110px;
              top: 36px;
              background-color: #fff;
              width: 180px;
              height: 210px;
              color: #5a5a5a;
              .code {
                width: 156px;
                height: 156px;
                margin: 15px auto 10px;
                background-color: #33383c;
              }
            }
          }
          > span {
            cursor: pointer;
            display: inline-block;
            vertical-align: middle;
            i,
            span {
              display: inline-block;
              vertical-align: middle;
            }
            &:nth-child(1) {
              i {
                width: 17px;
                height: 16px;
                background-position-y: -18px;
                margin-right: 6px;
                background-image: url('../assets/icon-fabulous2.png');
              }
              &.active {
                i {
                  background-position-y: 0;
                }
              }
            }
            &:nth-child(2) {
              margin-left: 14px;
              i {
                width: 17px;
                height: 16px;
                margin-right: 6px;
                background-image: url('../assets/icon-cai.png');
                background-position-x: 0;
              }
              &.active {
                i {
                  background-position-y: -16px;
                }
              }
            }
          }
        }
      }
    }
  }
  .story-body {
    padding-top: 22px;
    clear: both;
    color: #c7d1da;
    /deep/ .el-scrollbar__wrap {
      height: 490px;
      overflow-x: hidden;
    }
    /deep/ .el-scrollbar__thumb {
      background-color: #b5f0fa;
      left: 0px;
    }
    /deep/ .el-scrollbar__bar {
      opacity: 1;
      width: 6px;
    }
    p {
      line-height: 180%;
      text-align: left;
      padding-right: 30px;
    }
    .img-box {
      padding-right: 30px;
      height: 243px;
      margin-top: 20px;
      img {
        width: 100%;
      }
    }
  }
}
.x {
  position: absolute;
  right: -6px;
  top: 62px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  background-image: url('../assets/close.png');
}
/deep/.el-dialog {
  background-color: transparent;
  box-shadow: initial;
  width: 100%;
  height: 100%;
  display: table;
  margin: 0 !important;
}
/deep/.el-dialog__header {
  display: none;
}
/deep/.el-dialog__body {
  padding: 0;
  vertical-align: middle;
  display: table-cell;
}
/deep/ .el-scrollbar__wrap {
  height: 642px;
  overflow-x: hidden;
}
/deep/ .el-scrollbar__thumb {
  background-color: #34373d;
  left: 0px;
}
/deep/ .el-scrollbar__bar {
  opacity: 1;
  width: 6px;
}
</style>
